import { ArrowRight, ExternalLink, Mail, MonitorPlay, QrCode } from "lucide-react";
import { CanonicalUrl } from "@/features/profiles/components/ProfileThemeEditor";
import { IdentityQR } from "@/components/identity/IdentityQR";
import { InstallPanel } from "@/features/pwa/InstallPanel";
import { ROUTES } from "@/constants/routes";

const NEXT = [
  { key: "qr", label: "QR Identity", to: ROUTES.card, icon: QrCode },
  { key: "signature", label: "Email Signature", to: ROUTES.signature, icon: Mail },
  { key: "background", label: "Meeting Background", to: ROUTES.background, icon: MonitorPlay },
];

export function PublishSuccess({ result, onFinish }) {
  return (
    <section data-testid="publish-success" className="mw-rise">
      <p className="mw-eyebrow">Published</p>
      <h1 className="mt-3 font-serif text-4xl tracking-tight sm:text-6xl">You're live.</h1>
      <p className="mt-6 max-w-xl text-base leading-relaxed text-muted-foreground sm:text-lg">
        Your digital business card and public profile are published. Share your link anywhere.
      </p>
      <div className="mt-10 rounded-lg border border-border bg-card p-5 sm:p-6">
        <div className="flex flex-col gap-6 sm:flex-row sm:items-center">
          <IdentityQR value={result.url} size={112} testId="success-qr" />
          <div className="min-w-0 flex-1"><CanonicalUrl url={result.url} note={null} testPrefix="success" /></div>
        </div>
        <a href={`/${result.slug}`} target="_blank" rel="noreferrer" data-testid="success-view-profile-link" className="mw-link mt-4 inline-flex min-h-[44px] items-center gap-2 text-sm">
          View live profile <ExternalLink className="h-3.5 w-3.5" />
        </a>
      </div>
      <div className="mt-6 flex flex-col gap-3 sm:flex-row sm:flex-wrap">
        {NEXT.map(({ key, label, to, icon: Icon }) => (
          <button key={key} type="button" onClick={() => onFinish(to)} data-testid={`success-${key}-link`} className="mw-btn mw-btn-ghost">
            <Icon className="h-4 w-4" /> {label}
          </button>
        ))}
      </div>
      <div className="mt-6 rounded-lg border border-border bg-card p-5"><InstallPanel /></div>
      <button type="button" onClick={() => onFinish(ROUTES.dashboard)} data-testid="success-dashboard-button" className="mw-btn mw-btn-primary mt-12">
        Go to dashboard <ArrowRight className="h-4 w-4" />
      </button>
    </section>
  );
}
